import { z } from "zod";

/**
 * Editable fragments of the run-level problem-key canonicalizer's prompt,
 * stored in a prompt_bundles row and delivered through the run-scoped MCP
 * briefing (get_canonicalization_briefing). Assembly stays in worker code
 * (workers/yeet/src/canonicalize-llm.ts); only the text lives here.
 */
export const YeetCanonicalizerPromptDocumentSchema = z
  .object({
    persona: z.string().min(1),
    mergePolicy: z.string().min(1),
    outputSpec: z.string().min(1),
  })
  .strict();
export type YeetCanonicalizerPromptDocument = z.infer<
  typeof YeetCanonicalizerPromptDocumentSchema
>;
